<template>
    <div class="spinner-overlay" v-if="model.showSpinner">
        <span class="spinner"></span>
    </div>
</template>

<script lang="ts">
import { AppFullscreenSpinner } from "./app-fullscreen-spinner";
export default AppFullscreenSpinner;
</script>

<style scoped lang="scss">
@import "../../../shared/styles/mixins";

.spinner-overlay {
    position: fixed;
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 99999;
}

.spinner {
    transform: translate(-50%, -50%);
    z-index: 1000;
    font-size: 50px;
    border: 10px solid #f3f3f3;
    border-top: 10px solid #1890ff;
    border-radius: 50%;
    width: 120px;
    height: 120px;
    animation: spin 1s linear infinite;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    position: fixed;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
